// extracted by mini-css-extract-plugin
export default {"LegalEntity":"styles_LegalEntity__i7FF+"};